// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditStructureMap_page__c-96y {
  margin: 2rem auto 3rem;
  width: 94%;
}

.EditStructureMap_header__HsDB5 {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.EditStructureMap_header__HsDB5 p {
  color: #596b7c;
  margin: 0.35rem 0 0;
}

.EditStructureMap_actions__kAKd4 {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.EditStructureMap_card__9LXED {
  width: 100%;
}

.EditStructureMap_metadata__wV4Eq {
  margin-bottom: 1rem;
}

@media (max-width: 767px) {
  .EditStructureMap_page__c-96y {
    width: 96%;
  }
  .EditStructureMap_header__HsDB5 {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/StructureMaps/EditStructureMap.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".page {\n  margin: 2rem auto 3rem;\n  width: 94%;\n}\n\n.header {\n  align-items: flex-start;\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.header p {\n  color: #596b7c;\n  margin: 0.35rem 0 0;\n}\n\n.actions {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.card {\n  width: 100%;\n}\n\n.metadata {\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 767px) {\n  .page {\n    width: 96%;\n  }\n  .header {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `EditStructureMap_page__c-96y`,
	"header": `EditStructureMap_header__HsDB5`,
	"actions": `EditStructureMap_actions__kAKd4`,
	"card": `EditStructureMap_card__9LXED`,
	"metadata": `EditStructureMap_metadata__wV4Eq`
};
export default ___CSS_LOADER_EXPORT___;
